// @ts-nocheck
// FIXME remove the above ts-nocheck and fix all the issues
import VideoTg24roomWidgets, {
  IEndpointsQueryParams,
  IVideoTg24roomWidgetsConfig,
  IDoFetchParams,
} from '@sky-it-video/video-tg24room-widgets';

import { getSETTINGS } from '../../utils/service-config';

const widgetsConfig = (): IVideoTg24roomWidgetsConfig => {
  try {
    return getSETTINGS();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error in Service configuration', error);
    return {};
  }
};

const videoTg24roomWidgets = new VideoTg24roomWidgets(widgetsConfig());

const getVideoDataSearch = 'getVideoDataSearch';

const createEndpointsQueryParams = (hashSubSubSection: string[], page: number): IEndpointsQueryParams | undefined => {
  const { section, count, total } = getSETTINGS(getVideoDataSearch).queryParams;

  const params = {
    count,
    page,
    section,
    subsection: hashSubSubSection[0],
    total,
  };

  if (!params.subsection.length) {
    params.tags = 'teamstudio';
  }
  return {
    [getVideoDataSearch]: {
      ...params,
    },
  };
};

function createDoFetchParams<T>(hashTags: string[], page: number, oldModel?: T): IDoFetchParams<T> {
  const endpoints = oldModel ? [getVideoDataSearch] : undefined;
  const queryParams = createEndpointsQueryParams(hashTags, page);

  return {
    endpointsQueryParams: queryParams,
    oldModel,
    endpoints,
  };
}

export const doGetVideoDataSearchFetch = async (hashTags: string[], page: number, oldModel?: T) => {
  try {
    const model: T = (await videoTg24roomWidgets.doFetch(createDoFetchParams(hashTags, page, oldModel))) as T;
    return model;
  } catch (error) {
    throw Error(error);
  }
};
